import React from 'react'
import { Container, Card, Icon, Table, Checkbox, Button } from 'semantic-ui-react';
import { dispatch } from '@rematch/core';
import { withRouter } from 'react-router-dom';
import { source } from 'react-aim';
import ImageAvater from '../../../drive/Components/ImageAvater';
import camelCaseCovert from '../../../../helpers/convert-camel-case';
import LoadingComponent from '../../../common/LoadingComponent';
import { Input } from 'semantic-ui-react'
import BreadCrumbOrganization from '../drive/cards/BreadCrumbOrganization';
const _ = require('lodash');

@source({
    mouseEnter: (props, component) => {
        dispatch.app.setHelpContext("Permissions");
    }
})

class ManagePermissions extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            added: [],
            removed: []
        }

    }

    componentDidMount() {
        const { history } = this.props;
        let userRole = this.props.user.accounts.filter(account => { return account._id.toString() === this.props.match.params.accountId.toString() });
        if (userRole.role !== "customerAdmin" && this.props.selectedOrganisation.role !== "workspaceOwner" && !(this.props.selectedAccount.planId.includes('premium') || this.props.selectedAccount.planId.includes('enterprise'))) {
            history.push(`/app/${this.props.match.params.accountId}/403`)
        }
        dispatch.community.addMainAreaContext("Permissions");
        dispatch.users.getAccountUsersWithPermissions({ organizationId: this.props.match.params.workspaceId })
    }
    templateCreationPermissionChanged(user) {
        if (user.permissions.filter(permission => { return permission.name === "templateCreation" }).length > 0) {
            for (let i = 0; i < user.permissions.length; i++) {
                if (user.permissions[i].name === "templateCreation") {
                    if (user.permissions[i].isRemoved) {
                        if (this.state.removed.filter(permission => { return permission.accountUserId.toString() === user._id.toString() && permission.name === "templateCreation" }).length > 0) {
                            let newRemoved = this.state.removed.filter(permission => { return !(permission.accountUserId.toString() === user._id.toString() && permission.name === "templateCreation") })
                            this.setState({ removed: newRemoved });
                        }
                        else if (!user.permissions[i]._id) {
                            this.setState({ added: [...this.state.added, user.permissions[i]] })
                        }

                        user.permissions[i].isRemoved = false;
                    }
                    else {
                        if (this.state.added.filter(permission => { return permission.accountUserId.toString() === user._id.toString() && permission.name === "templateCreation" }).length > 0) {
                            let newAdded = this.state.added.filter(permission => { return !(permission.accountUserId.toString() === user._id.toString() && permission.name === "templateCreation") })
                            this.setState({ added: newAdded });
                        }
                        else {
                            this.setState({ removed: [...this.state.removed, user.permissions[i]] })
                        }

                        user.permissions[i].isRemoved = true;
                    }
                    break;
                }
            }
        }
        else {
            if (this.state.removed.filter(permission => { return permission.accountUserId.toString() === user._id.toString() && permission.name === "templateCreation" }).length > 0) {
                let newRemoved = this.state.removed.filter(permission => { return !(permission.accountUserId.toString() === user._id.toString() && permission.name === "templateCreation") })
                this.setState({ removed: newRemoved });
            }
            else {
                this.setState({ added: [...this.state.added, { name: "templateCreation", accountUserId: user._id }] })
            }
            user.permissions.push({ name: "templateCreation", accountUserId: user._id });
        }
        dispatch.users.setUsersWithPermissions(Object.assign([], this.props.usersWithPermission))
    }
    dashboardCreationPermissionChanged(user) {
        if (user.permissions.filter(permission => { return permission.name === "dashboardCreation" }).length > 0) {
            for (let i = 0; i < user.permissions.length; i++) {
                if (user.permissions[i].name === "dashboardCreation") {
                    if (user.permissions[i].isRemoved) {
                        if (this.state.removed.filter(permission => { return permission.accountUserId.toString() === user._id.toString() && permission.name === "dashboardCreation" }).length > 0) {
                            let newRemoved = this.state.removed.filter(permission => { return !(permission.accountUserId.toString() === user._id.toString() && permission.name === "dashboardCreation") })
                            this.setState({ removed: newRemoved });
                        }
                        else if (!user.permissions[i]._id) {
                            this.setState({ added: [...this.state.added, user.permissions[i]] })
                        }
                        user.permissions[i].isRemoved = false;
                    }
                    else {
                        if (this.state.added.filter(permission => { return permission.accountUserId.toString() === user._id.toString() && permission.name === "dashboardCreation" }).length > 0) {
                            let newAdded = this.state.added.filter(permission => { return !(permission.accountUserId.toString() === user._id.toString() && permission.name === "dashboardCreation") })
                            this.setState({ added: newAdded });
                        }
                        else {
                            this.setState({ removed: [...this.state.removed, user.permissions[i]] })
                        }
                        user.permissions[i].isRemoved = true;
                    }
                    break;
                }
            }
        }
        else {
            if (this.state.removed.filter(permission => { return permission.accountUserId.toString() === user._id.toString() && permission.name === "dashboardCreation" }).length > 0) {
                let newRemoved = this.state.removed.filter(permission => { return !(permission.accountUserId.toString() === user._id.toString() && permission.name === "dashboardCreation") })
                this.setState({ removed: newRemoved });
            }
            else {
                this.setState({ added: [...this.state.added, { name: "dashboardCreation", accountUserId: user._id }] })
            }
            user.permissions.push({ name: "dashboardCreation", accountUserId: user._id });
        }
        dispatch.users.setUsersWithPermissions(Object.assign([], this.props.usersWithPermission))
    }
    onSave = async () => {

        let removals = [];
        this.state.removed.map(permission => {
            removals.push(permission._id);
        })
        await dispatch.users.updatePermissions({ additions: this.state.added, removals: removals, organizationId: this.props.match.params.workspaceId, accountId: this.props.match.params.accountId })
        this.setState({ added: [], removed: [] })
    }
    cancel = async () => {
        await dispatch.users.getAccountUsersWithPermissions();
    }
    searchData = (e, data) => {
        if (e.target.value) {
            dispatch.users.getAccountUsersWithPermissions({ organizationId: this.props.match.params.workspaceId, searchParam: e.target.value })
        }
        else {
            dispatch.users.getAccountUsersWithPermissions({ organizationId: this.props.match.params.workspaceId })
        }
    }
    render() {
        return (
            <Container fluid>
                <BreadCrumbOrganization {...this.props} />
                <div className="orgButtonList" >
                    <LoadingComponent active={this.props.loadingPermissions} message="Fetching Permissions..." />
                    <Input size='big' placeholder='Search by name or email' style={{ width: "100%" }} onChange={this.searchData} />
                    <Table celled columns={4}>
                        <Table.Header>
                            <Table.Row>
                                <Table.HeaderCell><strong>Workspace Users</strong> <br /> Roles</Table.HeaderCell>
                                <Table.HeaderCell><strong>Email</strong></Table.HeaderCell>
                                <Table.HeaderCell>Create Dashboard template</Table.HeaderCell>
                                <Table.HeaderCell>Create Dashboard</Table.HeaderCell>
                            </Table.Row>

                        </Table.Header>

                        <Table.Body>
                            {this.props.usersWithPermission && this.props.usersWithPermission.map(user => {
                                return (<Table.Row key={user._id}>
                                    <Table.Cell><ImageAvater user={user} /> <strong>{user.firstName + " " + user.lastName}</strong><br />{camelCaseCovert(user.role)}</Table.Cell>
                                    <Table.Cell>{user.email}</Table.Cell>
                                    <Table.Cell textAlign='center'>
                                        <Checkbox
                                            checked={user.permissions.filter(permission => { return permission.name === "templateCreation" && !permission.isRemoved }).length > 0}
                                            onChange={() => this.templateCreationPermissionChanged(user)} />
                                    </Table.Cell>
                                    <Table.Cell textAlign='center'>
                                        <Checkbox
                                            checked={user.permissions.filter(permission => { return permission.name === "dashboardCreation" && !permission.isRemoved }).length > 0}
                                            onChange={() => this.dashboardCreationPermissionChanged(user)} />
                                    </Table.Cell>

                                </Table.Row>)
                            })}


                        </Table.Body>
                    </Table>
                    {(this.state.added.length > 0 || this.state.removed.length > 0) && <div className="pull-right">
                        <Button onClick={this.cancel}>Cancel</Button>
                        <Button onClick={this.onSave} className="button-submit">Save</Button></div>}
                </div>
            </Container>)
    }
}

export default withRouter(ManagePermissions)